import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    DeleteQidDatapoint,
    setQidDatapointDelete,
    setQidDatapointReloadList,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
    Button,
    FormGroup,
    Label,
    Delimiter,
} from "client/components"
import { DatapointTitle } from "./styled"


export const ConfirmDelete = () => {
    const datapointGroup = useSelector((state: StoreType) => state.qidDatapoint.datapointDelete)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setQidDatapointDelete(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        const promiseArray: Promise<any>[] = []

        // nested datapoints based on failure modes will be removed automatically
        datapointGroup.datapoints.forEach((datapoint) => {
            promiseArray.push(DeleteQidDatapoint(datapoint))
        })
        Promise.all(promiseArray).then(() => {
            setDeleteState(IDLE)
            dispatch(setQidDatapointDelete(null))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidDatapointReloadList(true))
            }, 0)
        })
    }

    const model = datapointGroup ? datapointGroup.parents.model : null
    const safetyFunction = datapointGroup ? datapointGroup.parents.safetyFunction : null
    const option = datapointGroup ? datapointGroup.parents.option : null

    return (
        <ConfirmWrapper show={!!datapointGroup} onClose={onCancel}>
            <Confirm>
                {
                    model && (
                        <FormGroup inline>
                            <Label>{`${lang.model}:`}</Label>
                            <DatapointTitle>{model.name}</DatapointTitle>
                        </FormGroup>
                    )
                }
                {
                    safetyFunction && (
                        <FormGroup inline>
                            <Label>{`${lang.safetyFunction}:`}</Label>
                            <DatapointTitle>{safetyFunction.name}</DatapointTitle>
                        </FormGroup>
                    )
                }
                {
                    option && (
                        <FormGroup inline>
                            <Label>{`${lang.option}:`}</Label>
                            <DatapointTitle>{option.name}</DatapointTitle>
                        </FormGroup>
                    )
                }

                <Delimiter size="xs" />
                <ConfirmDescription>{lang.confirmDeleteDatapoints}</ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmDelete}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDelete
